import "./search.css";
import { useNavigate } from "react-router-dom";
import imageSrc from "../../assets/image/search.webp";
import { AutoComplete, Input, Form, ConfigProvider, Button } from "antd";
// import Form from "react-bootstrap/Form";
// import InputGroup from "react-bootstrap/InputGroup";/
import FeaturedEvent from "../home/FeaturedEvent";
import Category from "../home/Category";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { getSearchSuggestion } from "../../api/api";
import AOS from "aos";
import "aos/dist/aos.css";
import { loadMetaPixel, trackMetaPixel } from "../../helpers/metaPixel";
const Search = () => {
  const navigate = useNavigate();

  const { register, handleSubmit } = useForm();
  const [searchSuggestion, setSearchSuggestion] = useState([]);
  const onSubmit = (data) => {
    const query = String(data.search || "").trim();
    if (query && loadMetaPixel()) {
      trackMetaPixel("Search", { search_string: query });
    }
    navigate(`/event`, { state: { search: data.search } });
  };

  const navigation = [
    { title: "Inicio", path: "/event" },
    { title: "Buscar", path: "/search" },
  ];

  const navigationList = navigation.map((item, index) => (
    <>
      <span
        key={index}
        onClick={index < navigation.length - 1 ? () => navigate(item.path) : undefined}
        className="pageheader-navigation-text"
        style={{ cursor: "pointer" }}
      >
        {item.title}
      </span>
      {index < navigation.length - 1 && <span className="pageheader-navigation-arrow">{">>"}</span>}
    </>
  ));

  const fetchSearchSuggestion = async (value) => {
    try {
      const data = {
        searchQuery: value,
      };
      const response = await getSearchSuggestion(data);
      if (response.status === 200) {
        setSearchSuggestion(response.data.info);
        // console.log(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 900;
      },
    });
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="search-pageheader" style={{ backgroundImage: `url(${imageSrc})` }}>
        <div className="search-pageheader-title">
          <div className="search-pageheader-title-text" data-aos="fade-up">
            Buscar
          </div>
          <div
            className="search-pageheader-navigation"
            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {navigationList}
          </div>

          {/* <Form onSubmit={handleSubmit(onSubmit)} className="serch-form">
            <div className="search-pageheader-search">
              <InputGroup size="lg" className="shadow-sm">
                <button className="search-pageheader-search-svg">
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.7507 0.666657C6.62119 0.666753 5.50809 0.93696 4.50425 1.45473C3.50041 1.97251 2.63494 2.72284 1.98006 3.64312C1.32518 4.5634 0.899874 5.62695 0.739623 6.74503C0.579372 7.86311 0.688824 9.0033 1.05885 10.0705C1.42887 11.1377 2.04874 12.1009 2.86673 12.8798C3.68472 13.6587 4.67712 14.2306 5.76113 14.548C6.84513 14.8653 7.98932 14.9189 9.09822 14.7041C10.2071 14.4893 11.2486 14.0125 12.1357 13.3133L15.179 16.3567C15.3362 16.5085 15.5467 16.5925 15.7652 16.5906C15.9837 16.5887 16.1927 16.501 16.3472 16.3465C16.5017 16.192 16.5894 15.983 16.5913 15.7645C16.5932 15.546 16.5092 15.3355 16.3574 15.1783L13.314 12.135C14.1374 11.0905 14.65 9.83532 14.7933 8.51309C14.9366 7.19087 14.7047 5.85501 14.1242 4.6584C13.5437 3.4618 12.6381 2.45279 11.511 1.74685C10.3838 1.04091 9.08067 0.666567 7.7507 0.666657ZM2.33403 7.74999C2.33403 6.3134 2.90472 4.93565 3.92054 3.91983C4.93636 2.90401 6.31411 2.33332 7.7507 2.33332C9.18729 2.33332 10.565 2.90401 11.5809 3.91983C12.5967 4.93565 13.1674 6.3134 13.1674 7.74999C13.1674 9.18658 12.5967 10.5643 11.5809 11.5802C10.565 12.596 9.18729 13.1667 7.7507 13.1667C6.31411 13.1667 4.93636 12.596 3.92054 11.5802C2.90472 10.5643 2.33403 9.18658 2.33403 7.74999Z"
                      fill="#0D263C"
                    />
                  </svg>
                </button>

                <Form.Control
                  autoComplete="off"
                  className="search-pageheader-search-input"
                  type="text"
                  placeholder="Enter Keyword"
                  {...register("search", { required: true })}
                />
              </InputGroup>

              <button type="submit" className="search-pageheader-search-button">
                Search
              </button>
            </div>
          </Form> */}
          <Form onSubmit={handleSubmit(onSubmit)} className="serch-form">
            <ConfigProvider
              theme={{
                components: {
                  Input: {
                    colorText: "#0D263C",
                    backgroundColor: "#EAF0F5",
                    activeBorderColor: "#EC6325",
                    hoverBorderColor: "#EC6325",
                    colorFillAlter: "#EC6325",
                    fontWeight: "600",
                    inputFontSize: 12,
                    color: "#0D263C",
                  },
                },
              }}
            >
              <AutoComplete
                onSearch={(value) => {
                  fetchSearchSuggestion(value);
                }}
                options={searchSuggestion
                  ?.filter((item) => item && item.name)
                  .map((item) => ({
                    value: item?._id || "",
                    label: item?.name || "Desconocido",
                  }))}
                // options={searchSuggestion}
                onSelect={(value) => {
                  navigate(`/event/${value}`, {
                    state: { name: searchSuggestion.find((item) => item._id === value).name },
                  });
                }}
                style={{ width: "100%" }}
                size="large"
              >
                <Input.Search
                  size="large"
                  enterButton={
                    <Button
                      style={{
                        color: "#F9FCFF",
                        backgroundColor: "#EC6325",
                        borderColor: "#EC6325",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Buscar
                    </Button>
                  }
                  placeholder="Introduce una palabra clave"
                  style={{
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "#0D263C",
                  }}
                  onSearch={(value) => {
                    if (value !== "") {
                      if (loadMetaPixel()) {
                        trackMetaPixel("Search", { search_string: value });
                      }
                      navigate(`/event`, { state: { search: value } });
                    }
                  }}
                  {...register("search", { required: true })}
                />
              </AutoComplete>
            </ConfigProvider>
          </Form>
        </div>
      </div>
      <div className="pading150">
        <Category />
      </div>
      <div>
        <FeaturedEvent bgColor="#DFE7ED" />
      </div>
    </>
  );
};

export default Search;
